export const tabToOfferStateMap = {
    enquired: ['ENQUIRY', 'QUOTED'],
    ordered: ['ORDER', 'CUSTOMER_ADJUSTED', 'SUPPLIER_ADJUSTED'],
    acknowledged: ['ACKNOWLEDGED'],
    confirmed: ['CONFIRMED'],
    delivered: ['DELIVERED', 'DELIVERY_CONFIRMED', 'INVOICED'],
    expired: ['QUOTE_DECLINED', 'ENQUIRY_EXPIRED'],
    canceled: ['CANCELED', 'ENQUIRY_CANCELED', 'QUOTE_CANCELED', 'ENQUIRY_DECLINED'],
};
